import React from "react";
import { withTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ProductCard from "../../components/ProductCard/ProductCard";
import { HashLink } from "react-router-hash-link";
import { CloudCheck, ShieldAlert, GraduationCap, MonitorCog } from "lucide-react";
import Scaler from "../Home/scaler.png";
import Calendar from "../Home/calendar.png";
import Investment from "../Home/investment.png";
import Coins from "../Home/coins.png";
import Cert from "../Home/cert.png";
import Wzrost from "../Home/wzrost.png";
import "./AbcInwestora.sass";

class AbcInwestora extends React.Component {
  componentDidMount() {
    document.title = "ABC Nowego Inwestora — BluHolding";
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Header />
        <div className="Home AbcInwestora">
          <h1 className="Subpage__title">{t("abcPageTitle")}</h1>

          <section className="section">
            <div className="w100 flex justify-center">
              <h2>{t("whatIs")} BluHolding?</h2>
            </div>
            <div className="section__block section__block--white">
              <p>{t("content1par1")}</p>
            </div>
          </section>

          <section className="section--gray">
            <div className="w100 flex justify-center">
              <h2>{t("abcAboutHoldingHeading")}</h2>
            </div>
            <div className="section__block section__block--white">
              <p>{t("content1par2")}</p>
              <p>{t("content1par3")}</p>
              <p>{t("content1par4")}</p>
            </div>
          </section>

          <section className="section">
            <div className="w100 flex justify-center">
              <h2>BluHolding {t("inNumbers")}</h2>
            </div>
            <div className="section__block--transparent grid--custom-numbers">
              <div className="card--small">
                <img src={Scaler} alt="Rozwój" />
                <p><b>{t("publicDevelopmentStatus")}</b></p>
                <p>{t("publicDevelopmentStatusValue")}</p>
              </div>
              <div className="card--small">
                <img src={Calendar} alt="Doświadczenie" />
                <p><b>{t("publicExperience")}</b></p>
                <p>{t("publicExperienceValue")}</p>
              </div>
              <div className="card--small">
                <img src={Investment} alt="Specjalizacje" />
                <p><b>{t("publicSpecializations")}</b></p>
                <p>{t("publicSpecializationsValue")}</p>
              </div>
              <div className="card--small">
                <img src={Coins} alt="Skala działania" />
                <p><b>{t("publicOperationalPresence")}</b></p>
                <p>{t("publicOperationalPresenceValue")}</p>
              </div>
              <div className="card--small">
                <img src={Cert} alt="Marki" />
                <p><b>{t("publicBrandsCount")}</b></p>
                <p>{t("publicBrandsCountValue")}</p>
              </div>
              <div className="card--small">
                <img src={Wzrost} alt="Obszary działalności" />
                <p><b>{t("publicBusinessAreas")}</b></p>
                <p>{t("publicBusinessAreasValue")}</p>
              </div>
            </div>
          </section>

          <section className="section--gray">
            <div className="w100 flex justify-center">
              <h2>{t("abcBusinessAreasHeading")}</h2>
            </div>
            <div className="our-brands our-brands--row">
              <ProductCard title={t("epulpitDevelopmentShort")} content={t("epulpitDevelopmentLong")}>
                <CloudCheck stroke="#172f73" />
              </ProductCard>
              <ProductCard title={t("cyberAuditShort")} content={t("cyberAuditLong")}>
                <ShieldAlert stroke="#172f73" />
              </ProductCard>
              <ProductCard title={t("trainingServicesShort")} content={t("trainingServicesLong")}>
                <GraduationCap stroke="#172f73" />
              </ProductCard>
              <ProductCard title={t("itServicesShort")} content={t("itServicesLong")}>
                <MonitorCog stroke="#172f73" />
              </ProductCard>
            </div>
          </section>

          <section className="section">
            <div className="Subpage__cta">
              <p>{t("abcClosingCta")}</p>
              <div className="Subpage__cta__buttons">
                <HashLink to="/materialy-inwestorskie" className="button--primary">
                  {t("abcCtaMaterials")}
                </HashLink>
                <HashLink to="/#kontakt-formularz" className="button--primary">
                  {t("abcCtaContact")}
                </HashLink>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(AbcInwestora);
